import type { ArticleType } from '@yi/core/src/gql/generated/typesSsr';

type Content = { entry_type: ArticleType };

export function isArticleWithMedia({ entry_type }: Content): boolean {
  const isMediaType = entry_type === 'VIDEO' || entry_type === 'AUDIO' || entry_type === 'LIVE';
  return isMediaType;
}
